import { type MutableRefObject } from 'react';

import type { Editor as TiptapEditor } from '@tiptap/core';

import { Copy } from '@spotify/confidence-core-react';

import { useCopyDocumentMarkdownValue } from '../hooks/useCopyAsMarkdown';

export const CopyAsMarkdownButton = ({
  editorRef,
}: {
  editorRef?: MutableRefObject<TiptapEditor | null>;
} = {}) => {
  const getValue = useCopyDocumentMarkdownValue(editorRef);

  return <Copy value={getValue} label="Copy as markdown" variant="compact" />;
};
